export default function BlockBackground() {
  return <div className="block-bg-layer" aria-hidden="true" />;
}
